import * as actionTypes from "../constants/actionTypes";
import * as reducerHelper from "../helpers/reducerHelper";
import * as modelHelper from "../helpers/modelHelper";
import * as config from "../constants/config";

const initialState = {
    customerList: [],
    lastCustomerList: [],
    customer: null,
    filter: "",
    offset: config.MAX_CUSTOMER_LIMIT
};

/**
 * Structure of customers store:
 * - customerList {Array}
 * - customer {Object}
 * - filter {String}
 * - offset {Number}
 */
export const customersReducer = (state = {}, action) => {
    switch (action.type) {
        case actionTypes.CUSTOMERS_TAB_INIT:
            if (state[action.payload.tabId] !== undefined) {
                return state;
            }

            let initState = {};
            initState[action.payload.tabId] = initialState;
            return {...state, ...initState};
        case actionTypes.FORMULA_STORE_INIT:
        case actionTypes.CONSTRUCT_SEARCH_PANEL:
        case actionTypes.TICKETING_TAB_INIT:
        case actionTypes.STATISTICS_TAB_INIT:
            let newInitState = {};
            newInitState[action.payload.tabId] = initialState;
            return {...state, ...newInitState};
        case actionTypes.SAVE_CUSTOMER_LIST:
            return reducerHelper.getNewState(
                action.payload.tabId,
                {
                    customerList: modelHelper.mapCustomersToObjects(action.payload.customerList)
                },
                state
            );
        case actionTypes.SAVE_LAST_CUSTOMER_LIST:
            return reducerHelper.getNewState(
                action.payload.tabId,
                {
                    lastCustomerList: modelHelper.mapCustomersToObjects(action.payload.lastCustomerList)
                },
                state
            );
        case actionTypes.SAVE_CUSTOMER_LIST_WITH_OFFSET:
            return reducerHelper.getNewState(
                action.payload.tabId,
                {
                    customerList: state[action.payload.tabId].customerList.concat(
                        modelHelper.mapCustomersToObjects(action.payload.customerList)
                    )
                },
                state
            );
        case actionTypes.SAVE_CUSTOMER_DETAIL:
            return reducerHelper.getNewState(
                action.payload.tabId,
                {
                    customer: modelHelper.mapCustomerToObject(action.payload.customer)
                },
                state
            );
        case actionTypes.MAIN_TAB_SET_CUSTOMER:
            return reducerHelper.getNewState(
                action.payload.tabId,
                {
                    customer: action.payload.customer,
                    filter: "",
                    offset: config.MAX_CUSTOMER_LIMIT
                },
                state
            );
        case actionTypes.CUSTOMERS_TAB_RESET:
            return reducerHelper.getNewState(
                action.payload.tabId,
                {
                    filter: "",
                    offset: config.MAX_CUSTOMER_LIMIT
                },
                state
            );
        case actionTypes.CUSTOMERS_CHANGE_FILTER:
            return reducerHelper.getNewState(
                action.payload.tabId,
                {
                    filter: action.payload.filter
                },
                state
            );
        case actionTypes.CUSTOMERS_CHANGE_OFFSET:
            return reducerHelper.getNewState(
                action.payload.tabId,
                {
                    offset: action.payload.offset
                },
                state
            );
        case actionTypes.MAIN_TAB_DELETE_CUSTOMER:
            return reducerHelper.getNewState(
                action.payload.tabId,
                {
                    customer: null
                },
                state
            );
        case actionTypes.CLOSE_ACTIVE_TAB:
        case actionTypes.CLOSE_ALL_TABS_EXCEPT_ACTIVE:
        case actionTypes.CLOSE_ALL_TABS:
            let closeState = {};

            let tab;
            for (tab of action.payload.newTabList) {
                if (state[tab.id] !== undefined) {
                    closeState[tab.id] = state[tab.id];
                }
            }

            return closeState;
        case actionTypes.LOG_OUT_SUCCESS:
        case actionTypes.WEBSOCKET_CLOSED:
        case actionTypes.DATABASE_CHANGE:
            return {};
        default:
            return state;
    }
};
